<template>
    <div class="tour-settings">
        <div class="tour-settings-content">
            <md-button class="md-icon-button close-tour-settings" @click="toggleShowSettings(false), closeSaveButton()">
                <md-icon>clear</md-icon>
            </md-button>
            <md-tabs class="centered-title" md-border-bottom md-dynamic-height>
                <md-tab md-label="Preferences">
                    <p v-if="recordUpdateSucc" style="    color: green;    position: fixed;    float: right;    right: 6%;">Record updated successfully!</p>
                    <md-button style="    color: green;    position: fixed;    float: right;    right: 6%; margin-top:10px;" class="md-raised md-primary" v-if="(routeSettingsChanged && !$v.currentRoute.$invalid) || forcommentaryNotification" @click="clickSaveRouteSettings()">Save</md-button>
                    <br><br><br><br>
                    <md-content>
                        <div class="wrap">
                            <section class="global-section">
                                <div class="row">
                                    <div class="col-4">
                                        <h2 class="section-title">Route Settings </h2>
                                    </div>
                                    <div class="col-8 align-col">

                                        <div class="row bottom-spacer">
                                            <div class="col-8">
                                                <h3>Commentary Notification</h3>
                                                <p class="light">Notifies passengers commentary will begin</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-8">
                                                <h3>Notification Sound</h3>
                                            </div>
                                        </div>
                                        <div class="row notification-sound-row">
                                            <div class="col-8">
                                                <md-field>
                                                    <md-select v-if="tourNotifications.length > 0" class="half-field" placeholder="Select a notification sound..." id="notificationSelect" v-model="currentRoute.notificationSongId">
                                                        <md-option :key="index" v-for="(notification, index) in tourNotifications" :value="notification.id">{{ notification.friendly_name }}</md-option>
                                                    </md-select>
                                                    <div v-else><h3>No notification sounds available.</h3></div>
                                                </md-field>
                                            </div>
                                            <div class="col-4 setting-col">
                                                <md-switch v-model="soundToggle" :value="true" @change="toggleNotificationSound($event)"></md-switch>
                                            </div>
                                        </div>
                                        <div class="row settings-form-error" v-if="$v.currentRoute.notificationSongId.$invalid && currentRoute.notificationSound === 1">
                                            <div class="col-8">
                                                Notifications are enabled, a notification sound must be selected.
                                            </div>
                                        </div>
                                        <div class="row bottom-spacer">
                                            <div class="col-8">
                                                <h3>Commentary Delay</h3>
                                                <p class="light">The delay between the notification and when the commentary begins. (1s to 9s)</p>
                                            </div>
                                            <div class="col-4 setting-col">
                                                <md-field :md-counter="false" md-no-float class="small-field">
                                                    <md-input maxlength="1" v-model="currentRoute.commentaryDelay"></md-input>
                                                </md-field>
                                            </div>
                                        </div>
                                        <div class="row settings-form-error" v-if="$v.currentRoute.commentaryDelay.$invalid">
                                            <div class="col-8">
                                                Please enter a valid number between 1 and 9
                                            </div>
                                        </div>

                                        <div class="row bottom-spacer">
                                            <div class="col-8">
                                                <h3>Seatback Notification</h3>
                                                <p class="light">*Only visible for the Navilution Evo system.</p>
                                            </div>
                                            <div class="col-4 setting-col">
                                                <md-switch v-model="seatbackToggle" :value="true" @change="toggleSeatbackNotification($event)"></md-switch>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-8">
                                                <h3>Seatback Illumination Notification</h3>
                                                <p class="light">Seatback LED flash. (2s to 9s)</p>
                                            </div>
                                            <div class="col-4 setting-col">
                                                <md-field :md-counter="false" md-no-float class="small-field">
                                                    <md-input maxlength="1" v-model="currentRoute.audioControllerFlashTime"></md-input>
                                                </md-field>
                                            </div>
                                        </div>
                                        <div class="row settings-form-error" v-if="$v.currentRoute.audioControllerFlashTime.$invalid">
                                            <div class="col-8">
                                                Please enter a valid number between 2 and 9
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </md-content>
                </md-tab>
            </md-tabs>
        </div>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import {required, numeric, minValue, maxValue, requiredIf} from 'vuelidate/lib/validators';

export default {
  data () {
    return {
      soundToggle: false,
      seatbackToggle: false,
      commentaryNotification: false,
      checkSaveOrNot: 1,
      forcommentaryNotification: false,
      recordUpdateSucc: false
    };
  },
  computed: {
    ...mapGetters('routes', ['currentRoute', 'routeSettingsChanged']),
    ...mapGetters('library', ['tourNotifications'])
  },
  methods: {
    ...mapActions('editor', ['toggleShowSettings']),
    ...mapActions('routes', ['saveRoute']),
    toggleNotificationSound (toggled) {
      if (toggled) {
        this.currentRoute.notificationSound = 1;
      } else {
        this.currentRoute.notificationSound = 0;
      }
    },
    closeSaveButton () {
      this.forcommentaryNotification = false;
    },
    toggleSeatbackNotification (toggled) {
      if (toggled) {
        this.currentRoute.audioControllerNotification = 1;
      } else {
        this.currentRoute.audioControllerNotification = 0;
      }
    },
    clickSaveRouteSettings () {
      this.saveRoute(this.currentRoute);
      this.checkSaveOrNot = 0;
      this.currentRoute.commentary = 0;
      this.forcommentaryNotification = false;
      this.recordUpdateSucc = true;
      setTimeout(() => {
        this.recordUpdateSucc = false;
      }, 3000);
    }
  },
  validations: {
    currentRoute: {
      commentaryDelay: {
        minValue: minValue(1),
        maxValue: maxValue(9),
        required,
        numeric
      },
      audioControllerFlashTime: {
        minValue: minValue(2),
        maxValue: maxValue(9),
        required,
        numeric
      },
      notificationSongId: {
        required: requiredIf(function () {
          return this.currentRoute.notificationSound === 1;
        })
      }
    }
  },
  mounted () {
    this.soundToggle = this.currentRoute.notificationSound === 1;
    this.seatbackToggle = this.currentRoute.audioControllerNotification === 1;
    this.commentaryNotification = this.currentRoute.commentary === 0;
    if (this.currentRoute.commentary === 1) {
      this.commentaryNotification = true;
    }
    var varForThis = this;
    this.$bus.$on('changevariableValueOfRouteSetting', function () {
      varForThis.saveRoute(varForThis.currentRoute);
      if (varForThis.checkSaveOrNot === 1) {
        //
      }
    });
  }
};
</script>
<style lang="scss">
.md-radio.md-theme-default.md-checked.md-primary .md-radio-container:after {
    background-color: #00A8CA !important;
}

.tour-settings {
    .md-field.small-field {
        width: 10px !important;

        input {
            width: 10px;
        }
    }

    .bottom-spacer {
        margin-bottom: 20px;
    }

    .notification-sound-row {
        margin-bottom: 20px;

        .md-switch {
            margin-bottom: 0px !important;
        }

        .md-field {
            padding: 0 !important;
            min-height: 0 !important;
        }
    }

    .setting-col {
        padding-top: 0px !important;
    }

    .md-field {
        margin: 0px !important;
    }

    .global-section {
        padding: 0 0 32px !important;
    }

    .settings-form-error {
        font-size: 12px;
        color: red;
        top: -20px;
        position: relative;
    }
}

.md-switch.md-theme-default.md-checked .md-switch-container {
    width: 34px;
    height: 14px;
}

.md-switch.md-theme-default.md-checked .md-switch-thumb {
    background-color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/RouteSettings.vue